"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createVitalSigns = createVitalSigns;
const shared_1 = require("../../shared");
const queries_1 = require("../queries");
const messages = {
    vitalSigns: {
        id: "dashboard.vital_signs",
        defaultMessage: "Vitális értékek"
    },
    systolicBloodPressure: {
        id: "dashboard.systolic_blood_pressure",
        defaultMessage: "Szisztolés vérnyomás"
    },
    diastolicBloodPressure: {
        id: "dashboard.diastolic_blood_pressure",
        defaultMessage: "Diasztolés vérnyomás"
    },
    heartRate: {
        id: "dashboard.heart_rate",
        defaultMessage: "Pulzus"
    }
};
const values = [
    {
        label: messages.systolicBloodPressure,
        query: queries_1.queries.systolicBloodPressure
    },
    {
        label: messages.diastolicBloodPressure,
        query: queries_1.queries.diastolicBloodPressure
    },
    {
        label: messages.heartRate,
        query: queries_1.queries.heartRate
    }
];
function createVitalSigns(intl, { events }) {
    return (0, shared_1.createList)(intl, {
        events,
        label: messages.vitalSigns,
        values,
        createItem: shared_1.createNumberListItem
    });
}
